const InputRequired = {
  borderLeft: "3px solid red",
};

export class StyleHelper {
  static get InputRequired() {
    return InputRequired;
  }
}
